// FAQ page (sections/main-faq.liquid): question counts, search, topic highlight, deep links.
// The questions are server-rendered <details>, so the page reads without this script.
(() => {
  const root = document.querySelector('[data-faq]');
  if (!root) return;

  const qas = [...root.querySelectorAll('details.faq_qa')];
  const topics = [...root.querySelectorAll('section.faq_topic')];
  const fold = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  qas.forEach((d) => { d.dataset.text = fold(d.textContent); });

  // Question count per topic in the topic list
  topics.forEach((t) => {
    const n = root.querySelector('.faq_toc-list a[href="#' + CSS.escape(t.id) + '"] [data-faq-count]');
    if (n) n.textContent = t.querySelectorAll('details.faq_qa').length;
  });

  // Prices in the tables: converted and formatted the way the delivery block on the product page does it
  const rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? Shopify.currency.rate : 1;
  const fmt = window.money_format;
  if (window.Shopify && Shopify.formatMoney && fmt) {
    root.querySelectorAll('td[data-amount-cents]').forEach((cell) => {
      const converted = Math.round(Number(cell.dataset.amountCents) * rate);
      let text = Shopify.formatMoney(converted, fmt);
      if (cell.dataset.trim) text = text.replace(/([.,])00(?!\d)/, '');
      cell.textContent = cell.dataset.prefix ? cell.dataset.prefix + ' ' + text : text;
    });
  }

  // Put the opened answer in the address bar, so it can be linked to
  qas.forEach((d) => {
    d.querySelector('summary').addEventListener('click', () => {
      setTimeout(() => {
        if (d.open) {
          try { history.replaceState(null, '', '#' + d.id); } catch (e) { /* the address bar is optional */ }
        }
      }, 0);
    });
  });

  // Search across questions and answers: every word must match, accents ignored
  const input = root.querySelector('[data-faq-search]');
  const status = root.querySelector('[data-faq-status]');
  const empty = root.querySelector('[data-faq-empty]');
  const emptyHeading = root.querySelector('[data-faq-empty-heading]');
  const statusTemplate = root.dataset.statusTemplate || '';
  const openAtStart = new Set(qas.filter((d) => d.open));
  const runSearch = () => {
    const raw = input.value.trim();
    const terms = fold(raw).split(/\s+/).filter(Boolean);
    let shown = 0;
    qas.forEach((d) => {
      const hit = terms.every((t) => d.dataset.text.includes(t));
      d.hidden = !hit;
      if (hit) shown++;
      d.open = terms.length ? hit : openAtStart.has(d);
    });
    topics.forEach((t) => { t.hidden = !t.querySelector('details.faq_qa:not([hidden])'); });
    empty.hidden = shown > 0;
    status.textContent = !terms.length ? '' : shown ? statusTemplate.replace('||query||', raw) : emptyHeading.textContent;
  };
  input.addEventListener('input', runSearch);
  root.querySelector('[data-faq-clear]').addEventListener('click', () => {
    input.value = '';
    runSearch();
    input.focus();
  });

  // Open the answer a link points at
  const openFromHash = () => {
    let id = '';
    try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
    const el = id && document.getElementById(id);
    if (el && el.matches('details.faq_qa')) {
      el.open = true;
      el.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    const el = document.getElementById(a.getAttribute('href').slice(1));
    if (el && el.matches('details.faq_qa')) el.open = true;
  });
  window.addEventListener('hashchange', openFromHash);
  openFromHash();

  // Highlight the topic being read
  const links = new Map([...root.querySelectorAll('.faq_toc-list a')].map((a) => [a.getAttribute('href').slice(1), a]));
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        links.forEach((a) => a.removeAttribute('aria-current'));
        const a = links.get(en.target.id);
        if (a) a.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    topics.forEach((t) => io.observe(t));
  }
})();
